import type { CodeSessionAgentEvent } from '@/lib/code-sessions/types';

export function eventData(event: CodeSessionAgentEvent): Record<string, unknown> {
  return typeof event.data === 'object' && event.data !== null
    ? (event.data as Record<string, unknown>)
    : {};
}

/**
 * Stream identity of a delta event. OpenCode ordinals count text and
 * reasoning parts *separately* per message (see noninteractive.ts
 * `textOrdinal`/`reasoningOrdinal`), so the key carries the part type:
 * `assistantMessageID:<text|reasoning>:ordinal`. Tool calls key by the tool
 * call id: `assistantMessageID:tool:<callId>`. Persisted content always wins
 * over an event-built part for the same key.
 */
export function streamKeyOf(
  partType: 'text' | 'reasoning',
  data: Record<string, unknown>,
): string | undefined {
  return typeof data.assistantMessageID === 'string' && typeof data.ordinal === 'number'
    ? `${data.assistantMessageID}:${partType}:${data.ordinal}`
    : undefined;
}
